/*---------- Deps, Hooks & CSS ----------*/
import { useState, useEffect, useRef } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import styles from "./KioskSetupStatusManager.module.css"

/*---------- Services ----------*/
import * as progressService from '../../../services/progressService'
import * as clientEventService from '../../../services/clientEventService'

/*---------- Components ----------*/
import Card from "../../../components/Home/StatusSubpages/Card"
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import ProgressSteps from '../../../components/Miscellaneous/ProgressSteps'

/*---------- Images ----------*/
import KioskSettings from "../../../components/Home/StatusSubpages/KioskSetupImages/KioskSettings.png"
import KioskEditScreen from "../../../components/Home/StatusSubpages/KioskSetupImages/KioskEditScreen.png"
import LandingPage from "../../../components/Home/StatusSubpages/KioskSetupImages/LandingPage.png"
import Scanner from "../../../components/Home/StatusSubpages/KioskSetupImages/Scanner.jpg"

const KioskSetupStatusManager = () => {

    const location = useLocation()
    const passedState = location.state
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    const [changeMade, setChangeMade] = useState(false)
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }
    }
    useEffect(() => {
        // run events fetch every x seconds, if its too fast, it won't run - gets stuck
        const interval = setInterval(() => checkClientEvent(), (30 * 1000))
        return () => clearInterval(interval)
    }, [])
    const checkClientEvent = () => {
        // Update clientevent with every render when its value has changed.
        let savedClientEvent = clientEventService.getClientEvent()
        if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
            savedClientEvent && savedClientEvent.eventId !== undefined &&
            savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
            setClientEventInfo(savedClientEvent)
            clientEventInfoRef.current = savedClientEvent;
            setChangeMade(true)
        }
    }
    useEffect(() => {
        if (changeMade && clientEventInfo && clientEventInfo.clientId !== undefined && clientEventInfo.clientName !== undefined
            && clientEventInfo.eventId !== undefined && clientEventInfo.eventName !== undefined) {
            setChangeMade(false)
            fetchData()
        }

    }, [clientEventInfo]) 

    /*---------- State ----------*/
     const [client, setClient] = useState(
        clientEventInfo
            ? clientEventInfo.client
            : clientEventInfo.clientId
                ? clientEventInfo.clientId
                : ""
    ) 
    const [event, setEvent] = useState(
        clientEventInfo.event
            ? clientEventInfo.event
            : clientEventInfo.eventId
                ? clientEventInfo.eventId
                : ""
    ) 
    const [clientEventObject, setClientEventObject] = useState({})
    const [loaded, setLoaded] = useState(false)

    // Required Setup
    const [kioskSetupProgress, setKioskSetupProgress] = useState("Loading...")
    const [editScreenProgress, setEditScreenProgress] = useState("Loading...")

    // Optional Setup
    const [landingPageProgress, setLandingPageProgress] = useState("Loading...")
    const [scannerPageProgress, setScannerPageProgress] = useState("Loading...")

    // Progress Steps
    const [requiredCompletionCount, setRequiredCompletionCount] = useState(1)
    const [optionalCompletionCount, setOptionalCompletionCount] = useState(1)

    /*---------- Constants ----------*/
    // General
    const clientName = clientEventInfo && clientEventInfo.clientName
        ? clientEventInfo.clientName
        : ""

    const eventName = clientEventInfo && clientEventInfo.eventName
            ? clientEventInfo.eventName
            : ""

    // curently does nothing, do we need it?
    const ERSName = clientEventInfo && clientEventInfo.eventRegistrationSystem !== undefined
        ? clientEventInfo.eventRegistrationSystem
        : "ERS"
    
    const clientId = clientEventInfo && clientEventInfo.clientId
        ? clientEventInfo.clientId
        : ""

    const eventId = clientEventInfo &&  clientEventInfo.eventId
            ? clientEventInfo.eventId
            : ""
    // Progress Steps 
    const requiredSteps = [
        { label: 'Kiosk Settings', step: 1 },
        { label: 'Edit Screen Setup', step: 2 },
    ]

    const optionalSteps = [
        { label: 'Landing Page Setup', step: 1 },
        { label: 'Scanner Page Setup', step: 2 },
    ]

    /*---------- Functions ----------*/
    // Step Calculations
    const checkRequiredCompletion = () => {
        if (kioskSetupProgress === "Success") setRequiredCompletionCount(count => count + 1)
        if (editScreenProgress === "Success") setRequiredCompletionCount(count => count + 1)
    }

    const checkOptionalCompletion = () => {
        if (landingPageProgress === "Success") setOptionalCompletionCount(count => count + 1)
        if (scannerPageProgress === "Success") setOptionalCompletionCount(count => count + 1)
    }

    const checkLoaded = () => {
        if (kioskSetupProgress !== "Loading..."
            && editScreenProgress !== "Loading..."
            && landingPageProgress !== "Loading..."
            && scannerPageProgress !== "Loading..."
        )
            setLoaded(true)
    }
    const fetchData = async () => {
        const clientEventObj = {
            ClientId: clientId,
            EventId: eventId,
        }
        setClientEventObject(clientEventObj)

        const [
            kioskProgress,
            editScreenStatus,
            landingProgress,
            scannerProgress,
        ] = await Promise.all([
            progressService.getKioskSettingProgress(clientEventObj),
            progressService.getEditScreenProgress(clientEventObj),
            progressService.getLandingPageProgress(clientEventObj),
            progressService.getScannerPageProgress(clientEventObj),
        ])

        setKioskSetupProgress(kioskProgress)
        setEditScreenProgress(editScreenStatus)
        setLandingPageProgress(landingProgress)
        setScannerPageProgress(scannerProgress)
    }
    useEffect(() => {
        if (clientEventInfo && clientEventInfo.clientId !== undefined && clientEventInfo.clientName !== undefined) {
            fetchData()
        }
    }, [clientEventInfo])
    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }
    }, [])

    useEffect(() => {
        checkLoaded()
        checkRequiredCompletion()
        checkOptionalCompletion()
    }, [scannerPageProgress])

    return (
        <>
            {
                loaded ?
                    <div id={styles.statusSubpage}>
                        <div className={styles.requiredSetupHeader}>
                            <h2 className={styles.requiredSetupHeading}>Required Setup</h2>
                            <ProgressSteps
                                steps={requiredSteps}
                                activeStep={requiredCompletionCount}
                            />
                        </div>

                        <div className={styles.container}>
                            <Card
                                dataImage={KioskSettings}
                                header="Kiosk Settings"
                                content={`Configure kiosk settings for the ${eventName}`}
                                styles={styles}
                                linkName={`/KioskSetup`}
                                linkState={clientEventInfo}
                                disabledBool={false} // hardcoded as it's the first required step of an event --- can't be disabled
                            />
                            <Card
                                dataImage={KioskEditScreen}
                                header="Edit Screen Setup"
                                content={`Manage kiosk edit screen settings for the ${eventName}`}
                                styles={styles}
                                linkName={`/KioskEditScreenLayout`}
                                linkState={clientEventInfo}
                                disabledBool={kioskSetupProgress !== "Success" ? true : false}
                            />
                        </div>

                        <div className={styles.optionalSetupHeader}>
                            <h2 className={styles.optionalSetupHeading}>Optional Setup</h2>
                            <ProgressSteps
                                steps={optionalSteps}
                                activeStep={optionalCompletionCount}
                            />
                        </div>

                        <div className={styles.container}>
                            <Card
                                dataImage={LandingPage}
                                header="Landing Page Setup"
                                content={`Configure kiosk landing page for the ${eventName}`}
                                styles={styles}
                                linkName={`/KioskLandingPageSetup`}
                                linkState={clientEventInfo}
                                disabledBool={editScreenProgress !== "Success" ? true : false}
                            />
                            <Card
                                dataImage={Scanner}
                                header="Scanner Setup"
                                content={`Attach an external or third-party barcode scanner to the kiosk`}
                                styles={styles}
                                linkName={`/KioskScannerPageSetup`} // There's no page for this yet
                                linkState={clientEventInfo}
                                disabledBool={editScreenProgress !== "Success" ? true : false}
                            />
                        </div>
                    </div>
                    :
                    <LoadingSpinner />
            }
        </>
    );
}

export default KioskSetupStatusManager;